module.exports = __webpack_public_path__ + "img/brand-18.0c14805d.png";